<template>
<div class="section has-text-centered is-paddingless">
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <h4 class="subtitle is-4">Invite others to use TwoSeven, get supporter privileges</h4>
        <p>
          Share your referral link with others. Get supporter privileges when they begin supporting TwoSeven. <br>
          There's no need to connect/watch with them to unlock benefits!
        </p>
      </div>
    </div>

    <div class="section has-text-centered">
      <div class="columns">
        <div class="column is-offset-2-widescreen is-8-widescreen has-text-centered">
          <div class="columns">
            <div class="column is-offset-1-widescreen is-10-widescreen is-offset-2-fullhd is-8-fullhd">
              <ReferralInputBox :referral-id="userProfile.referralID"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section has-text-centered">
      <h4 class="subtitle is-4">How it works</h4>
      <div class="columns">
        <div class="column is-offset-1-widescreen is-10-widescreen">
          <div class="columns">
            <div class="column">
              <div style="margin: 0.4em 0">
                <i-mdi-share-variant width="36" height="36"/>
              </div>
              <h5 class="subtitle is-5">
                Spread the Word
              </h5>
              <p>
                Tell others why you think they should use TwoSeven. Share your referral link on social media platforms to maximize your benefits!
              </p>
            </div>
            <div class="column">
              <div style="margin: 0.4em 0">
                <i-mdi-lock-open-variant width="36" height="36"/>
              </div>
              <h5 class="subtitle is-5">
                Unlock Privileges
              </h5>
              <p>
                The first time someone joinig through your referral link becomes a supporter of TwoSeven, you unlock {{ referralValidityDays }} days of supporter privileges for yourself!
              </p>
            </div>
            <div class="column">
              <div style="margin: 0.4em 0">
                <i-mdi-calendar-plus width="36" height="36"/>
              </div>
              <h5 class="subtitle is-5">
                Stack Benefits
              </h5>
              <p>
                The more people you refer who join and support TwoSeven, the longer your benefits last. There is no ceiling!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { toast } from '@/js/utils.js'
export default {
  name: 'referral-wiki',
  components: {
    ReferralInputBox: () => import(/* webpackChunkName: "referral-input-box" */ '@C/referral-input-box.vue')
  },
  props: {
    userProfile: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      referralValidityDays: 'several'
    }
  },
  methods: {
    toast,
    open () {
      this.$refs.modal.open()
    }
  },
  async beforeMount () {
    const response = await fetch('/api/unsecured/config/referralValidityDays')
    if (response.status !== 200) {
      return
    }
    const text = await response.text()
    this.referralValidityDays = text
  }
}
</script>
